import { onMessage } from "firebase/messaging";
import { Suspense, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Loader from "./components/Loader";
import SubscriptionExpiredBanner from "./components/SubsExpiredBanner";
import {
  filterIncompleteCommunityList,
  newFunctionTest,
  statusCode200,
} from "./helpers";
import useApi from "./Hooks/useApi";
import useScreenSize from "./Hooks/useScreenSize";
import { messaging } from "./notifications/firebase";

import { clearAllRanges } from "./store/ammenitiesRangeSlice";
import {
  activeCommunity,
  login,
  logout,
  setCommunitiesList,
  setIsSkip,
  setIsWaitListVerified,
  setNotiFlag,
  setPendingCommunityList,
  setWaitListData,
} from "./store/authSlice";
import { setNotifications } from "./store/notificationSlice";
import { setOnlinePaymentReceived } from "./store/onlinePaymentSlice";
import { setSubscriptionExpired } from "./store/subscriptionExpired";
import { setWalletPayment } from "./store/walletPaymentSlice";
// import Router from "../src/routes"
import Router from "./routes/router.js"
const App = () => {
  // const { communitiesList, communityId, communityName, communityCode, user } = useSelector(
  //   (state) => state?.authReducer
  // );
  const { deviceToken } = useSelector((state) => state?.FCMReducer);
  const {communityId,menu } = useSelector(
    (state) => state?.authReducer
  );


  console.log("Menu",menu)
  const api = useApi();
  // const { VerifyPaymentHanlder } = usePaymentStatus()
  const dispatch = useDispatch();
  const refreshUser = async () => {
    const response = await api.refreshUser();
    if (response?.data?.headers?.code === 200) {
      await dispatch(setNotiFlag(true));
      dispatch(login(response?.data?.body));
      dispatch(
        activeCommunity(
          newFunctionTest(response?.data?.body?.communityDetail, communityId)
        )
      );
      dispatch(setIsWaitListVerified(response?.data?.body?.isWaitListVerified));
      dispatch(
        setWaitListData({
          waitListPosition:
            response?.data?.body?.waitListDetail?.waitListPosition,
          totalWaitListUsers:
            response?.data?.body?.waitListDetail?.totalWaitListUsers,
        })
      );
      // dispatch(setCommunitiesList(editResidenceCommunityList(response?.data?.body?.communityDetail)));
      // dispatch(setCommunitiesList(filterQPCompany(response?.data?.body?.communityDetail)));
      dispatch(setCommunitiesList(response?.data?.body?.communityDetail));
      dispatch(
        setPendingCommunityList(
          filterIncompleteCommunityList(
            response?.data?.body?.communityDetail
          ) || null
        )
      );
      dispatch(setIsSkip(true));
      // toast.success("User Logged In Successfully");
    } else {
      toast.error(response?.data?.headers?.msg);
    }
  };

  const getAllNotificationsApi = async () => {
    const response = await api.GetNotificationsList();
    if (statusCode200(response)) { 
      dispatch(setNotifications(response?.data?.body?.items));
    } else {
      toast.error("Failed to fetch notifications");
    }
  };

  const showNotification = (message) => {
    // Alert.alert(JSON.stringify(message))
    message = JSON.parse(message);
    console.log(message, "messageaaa");
    if (message !== null) {
      if (message?.IsSuccess) {
        // Alert.alert('aa')
        toast.success(
          <div>
            <strong style={{ display: "block", marginBottom: "4px" }}>
              {message?.NotificationTitle ?? message?.Title}
            </strong>
            <span>{message?.ToastMessage ?? message?.Notification}</span>
          </div>
        );
      } else if (message?.NotificationTitle !== "") {
        console.log(message, "messageaaa22");
        toast.error(
          <div>
            <strong style={{ display: "block", marginBottom: "4px" }}>
              {message?.NotificationTitle ?? message?.Title}
            </strong>
            <span>{message?.ToastMessage ?? message?.Notification}</span>
          </div>
        );
      }
    }
  };

  const logoutHandler = () => {
    api.logout(deviceToken).then((response) => {
      if (response?.data?.headers?.code === 200) {
        dispatch(logout());
        dispatch(clearAllRanges());
        dispatch(setSubscriptionExpired(false));
        // dispatch(fcmHandler(""));
        toast.success("User Logged Out Successfully");
      } else {
        toast.error(response?.data?.headers?.msg);
      }
    });
  };
  onMessage(messaging, (payload) => {
    // toast.info(payload.notification.body)
    if (payload?.notification) {
      // toast.info(<div>
      //   <strong style={{ display: "block", marginBottom: "4px" }}>{payload?.notification?.title}</strong>
      //   <span>{payload?.notification?.body}</span>
      // </div>)

      showNotification(payload?.data?.msg);
    }
    console.log("LL Message received. ", payload);
    if (payload?.data?.topic === "UpdateSubscriptionDetail") {
      refreshUser();
    }

    if (payload?.data?.topic === "UpdateCommunityDetail") {
      refreshUser();
    }

    if (payload?.data?.topic === "DisbursedPayment") {
      console.log("payload?.data?.topi=", payload?.data?.topic);
      dispatch(setWalletPayment()); //incremet for listen the change
    }
    if (payload?.data?.topic === "OnlinePayment") {
      console.log("Online Data", payload);
      //online payment fail k case mein fcm nhi chaleyga
      dispatch(setOnlinePaymentReceived(true));

      // setShowNeemConfirmationModal(true);
      // getMaintenanceReportByMasterId()
      refreshUser();
    }
    if (payload?.data?.topic === "LogOut") {
      // VerifyPaymentHanlder()
      // refreshUser();
      console.log("case running...");
      console.log("LogoutFCM called");
      logoutHandler();
    }
    if (payload?.notification) {
      const transformedNotification = {
        message: payload?.data?.msg,
        createdDate: new Date().toISOString(),
        title: payload?.notification?.title,
        body: payload?.notification?.body,
        timestamp: new Date().toISOString(),
      };
      dispatch(setNotifications([transformedNotification]));

      // getAllNotificationsApi()
    }
  });
  return (
    <>
      {/* {screen?.width > 710 ? <> */}

      <ToastContainer />

      {/* {showNeemConfirmationModal && <NeemConfirmationModal show={showNeemConfirmationModal} setShow={setShowNeemConfirmationModal} />} */}

      {/* <HashRouter> */}
      <Suspense fallback={<Loader />}>
        {/* {
            isPending && <SubscriptionsStatusbar />
          } */}

        <SubscriptionExpiredBanner />
        <Router />
      </Suspense>
      {/* </HashRouter> */}
      {/* </> : <MobileView />} */}
    </>
  );
};

export default App;
